import {ChartingLibraryWidgetOptions, IChartingLibraryWidget} from "../../../../vendor/tradeview/charting_library";

export class TradingViewService {

    public static id = "tradingViewService";

    /** @ngInject */
    public constructor() {
    }

    public createEngine(config: ChartingLibraryWidgetOptions): IChartingLibraryWidget {
        return new TradingView.widget(config);
    }
}
